import * as React from "react";
import { useTheme } from "@fluentui/react";
import plannerAgentLogo from "@ms/uno-resources/lib/local/images/planneragent-squircle.svg";
import { Strings } from "@ms/uno-resources/lib/local/CultureUtilities";
import { BeanCounter } from "../beanCounter/BeanCounter";
import { getStyles, getClassNames } from "./AgentStatusIndicator.styles";
/**
 * Agent Status Indicator
 */ export const AgentStatusIndicator = (props)=>{
    const { customStyles, includeLogo = true, isFocusZoneEnabled = true } = props;
    const theme = useTheme();
    const classNames = getClassNames(getStyles(theme, customStyles));
    return /*#__PURE__*/ React.createElement("div", {
        className: classNames.agentStatusIndicatorStyle
    }, includeLogo && /*#__PURE__*/ React.createElement("img", {
        className: classNames.agentStatusIndicatorImageStyle,
        src: plannerAgentLogo,
        alt: ""
    }), /*#__PURE__*/ React.createElement("div", {
        tabIndex: isFocusZoneEnabled ? 0 : -1,
        "data-is-focusable": isFocusZoneEnabled,
        role: "status",
        "aria-label": Strings.CopilotStatus_WorkingOnIt
    }, Strings.CopilotStatus_WorkingOnIt), /*#__PURE__*/ React.createElement(BeanCounter, {
        maxDots: 3
    }));
};
